// reducers/demoRequestReducer.js
import {
  SUBMIT_DEMO_REQUEST,
  SUBMIT_DEMO_SUCCESS,
  SUBMIT_DEMO_FAILURE,
  RESET_DEMO_REQUEST_STATUS,
} from "../actions/demoRequestActions";

const initialState = {
  loading: false,
  successMessageSubmit: null,
  errorMessageSubmit: null,
};

const submitDemoRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_DEMO_REQUEST:
      return {
        ...state,
        loading: true,
        successMessageSubmit: null,
        errorMessageSubmit: null,
      };
    case SUBMIT_DEMO_SUCCESS:
      return {
        ...state,
        loading: false,
        successMessageSubmit: action.payload,
        errorMessageSubmit: null,
      };
    case SUBMIT_DEMO_FAILURE:
      return {
        ...state,
        loading: false,
        successMessageSubmit: null,
        errorMessageSubmit: action.payload,
      };
    case RESET_DEMO_REQUEST_STATUS:
      return {
        ...state,
        successMessageSubmit: null,
        errorMessageSubmit: null,
      };
    default:
      return state;
  }
};

export default submitDemoRequestReducer;
